import { useVersionCheck } from '@/hooks/useVersionCheck';

/**
 * Replaces the AlertController prompt in VersionCheckService. A banner rather
 * than a modal: the old version still works, so blocking the whole screen with
 * a non-dismissible dialog was heavier than the situation warrants.
 */
export function UpdateBanner() {
  const { updateAvailable } = useVersionCheck();
  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-3 bg-accent-solid px-4 py-2 text-sm text-white"
    >
      <span>A new version of Intraday Vision is available.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-md bg-white/15 px-3 py-1 font-medium hover:bg-white/25 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
      >
        Refresh now
      </button>
    </div>
  );
}
